// Chakra imports
import { useState } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import { Portal, Box, useDisclosure, useColorModeValue } from '@chakra-ui/react';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin';
import Sidebar from 'components/sidebar/Sidebar';
import Footer from 'components/footer/FooterAdmin';
import { SidebarContext } from 'contexts/SidebarContext';
import routes from 'routes';

export default function AdminLayout(props: { [x: string]: any }) {
	const { ...rest } = props;
	const contentBackgroundColor = useColorModeValue('gray.500', 'darkGray.500')
	// states and functions
	const [ fixed ] = useState(false);
	const [ toggleSidebar, setToggleSidebar ] = useState(false);
	// functions for changing the states from components
	const getRoute = () => {
		return window.location.pathname !== '/admin/full-screen-maps';
	};
	const getActiveRoute = (routes: RoutesType[]): string => {
		const activeRoute = 'Default Brand Text';
		routes.forEach(route => {

			if (window.location.href.indexOf(route.layout + route.path) !== -1) {
				return route.name;
			}
		})
		return activeRoute;
	};
	const getActiveNavbar = (routes: RoutesType[]): boolean => {
		const activeNavbar = false;
		routes.forEach(route => {
			if (window.location.href.indexOf(route.layout + route.path) !== -1) {
				return route.secondary;
			}
		})
		return activeNavbar;
	};
	const getActiveNavbarText = (routes: RoutesType[]): string | boolean => {
		const activeNavbar = false;
		routes.forEach(route => {
			if (window.location.href.indexOf(route.layout + route.path) !== -1) {
				return route.name;
			}
		})
		return activeNavbar;
	};
	const getRoutes = (routes: RoutesType[]): any => {
		return routes.map((route: RoutesType, key: any) => {
			if (route.layout === '/admin') {
				return <Route path={route.layout + route.path} component={route.component} key={key} />;
			} else {
				return null;
			}
		});
	};
	document.documentElement.dir = 'ltr';
	const { onOpen } = useDisclosure();
	return (
		<Box>
			<SidebarContext.Provider
				value={{
					toggleSidebar,
					setToggleSidebar
				}}>
				<Sidebar routes={routes} display='none' {...rest} />
				<Box
					float='right'
					minHeight='100vh'
					height='100%'
					overflow='auto'
					position='relative'
					maxHeight='100%'
					w={{ base: '100%', xl: 'calc( 100% - 300px )' }}
					maxWidth={{ base: '100%', xl: 'calc( 100% - 300px )' }}
					transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
					transitionDuration='.2s, .2s, .35s'
					transitionProperty='top, bottom, width'
					transitionTimingFunction='linear, linear, ease'>
					<Portal>
						<Box>
							<Navbar
								onOpen={onOpen}
								brandText={getActiveRoute(routes)}
								secondary={getActiveNavbar(routes)}
								message={getActiveNavbarText(routes)}
								fixed={fixed}
								{...rest}
							/>
						</Box>
					</Portal>

					{getRoute() ? (
						<Box mx='auto' p={{ base: '20px', md: '30px' }} pe='20px' pt='50px' bgColor={contentBackgroundColor}>
							<Switch>
								{getRoutes(routes)}
								<Redirect to='/admin/default' />
							</Switch>
						</Box>
					) : null}
					<Box bgColor={contentBackgroundColor}>
						<Footer />
					</Box>
				</Box>
			</SidebarContext.Provider>
		</Box>
	);
}
